module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/path.js
// module id = 15
// module chunks = 0 1